import { useEffect, useState } from 'react'
import { Col, Container, Modal, Row, Table } from 'react-bootstrap'
import { CashCoin, FloppyFill, GearFill } from 'react-bootstrap-icons'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import belaHomeSvg from '../../assets/belahome.svg'
import { Center } from '../../components/Center'
import { CustomButton } from '../../components/CustomButton'
import { CustomDecimalInput } from '../../components/CustomDecimalInput'
import { CustomPriceInput } from '../../components/CustomPriceInput'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
import { adaptValue } from '../../utils/adaptValue'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

export function MercadoLivreCalculoLucros() {
  const { state: product } = useLocation()

  const [isParametrosModalOpen, setIsParametrosModalOpen] = useState(false)

  const [produto, setProduto] = useState({
    frete_mercado_envios: '',
    preco_venda_produto: '',
  })

  const [userInput, setUserInput] = useState({
    quantidade: '',
    custo_produto: '',
    imposto: '',
    despesas_fixas: '',
    despesas_operacionais: '',
  })

  const [parametrosCusto, setParametrosCusto] = useState({
    preco_venda_ate: '',
    comissao_venda_classico: '',
    comissao_venda_premium: '',
    taxa_venda: '',
  })

  const [isSavePricesLoading, setIsSavePricesLoading] = useState(false)

  function formatValue(value) {
    if (
      Number(value) !== -Infinity &&
      Number(value) !== Infinity &&
      !isNaN(Number(value))
    ) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value)
    }
  }

  function formatPercentage(value) {
    if (
      Number(value) !== -Infinity &&
      Number(value) !== Infinity &&
      !isNaN(Number(value))
    ) {
      const valuePercentage = (value * 100).toFixed(2)

      return `${valuePercentage}%`
    }
  }

  const custoProdutoClassico = formatValue(
    adaptValue(userInput.custo_produto) * adaptValue(userInput?.quantidade),
  )

  const custoProdutoPremium = formatValue(
    adaptValue(userInput.custo_produto) * adaptValue(userInput?.quantidade),
  )

  const impostoClassico = formatValue(
    adaptValue(produto.preco_venda_produto) *
      (adaptValue(userInput.imposto) / 100),
  )

  const precoVendaProdutoPremium =
    adaptValue(produto.preco_venda_produto) * (6 / 100) +
    adaptValue(produto.preco_venda_produto)

  const impostoPremium = formatValue(
    adaptValue(precoVendaProdutoPremium) *
      (adaptValue(userInput.imposto) / 100),
  )

  const taxaExposicaoClassico = formatValue(
    adaptValue(produto.preco_venda_produto) <
      adaptValue(parametrosCusto.preco_venda_ate)
      ? adaptValue(produto.preco_venda_produto) *
          (adaptValue(parametrosCusto.comissao_venda_classico) / 100) +
          adaptValue(parametrosCusto.taxa_venda)
      : adaptValue(produto.preco_venda_produto) *
          (adaptValue(parametrosCusto.comissao_venda_classico) / 100),
  )

  const taxaExposicaoPremium = formatValue(
    precoVendaProdutoPremium < adaptValue(parametrosCusto.preco_venda_ate)
      ? precoVendaProdutoPremium *
          (adaptValue(parametrosCusto.comissao_venda_premium) / 100) +
          adaptValue(parametrosCusto.taxa_venda)
      : precoVendaProdutoPremium *
          (adaptValue(parametrosCusto.comissao_venda_premium) / 100),
  )

  const lucroClassico = formatValue(
    adaptValue(produto.preco_venda_produto) -
      (adaptValue(custoProdutoClassico) +
        adaptValue(impostoClassico) +
        adaptValue(userInput.despesas_fixas) +
        adaptValue(userInput.despesas_operacionais) +
        adaptValue(taxaExposicaoClassico) +
        adaptValue(produto.frete_mercado_envios)),
  )

  const lucroPremium = formatValue(
    adaptValue(precoVendaProdutoPremium) -
      (adaptValue(custoProdutoPremium) +
        adaptValue(impostoPremium) +
        adaptValue(userInput.despesas_fixas) +
        adaptValue(userInput.despesas_operacionais) +
        adaptValue(taxaExposicaoPremium) +
        adaptValue(produto.frete_mercado_envios)),
  )

  const totalDespesasClassico =
    adaptValue(impostoClassico) +
    adaptValue(userInput.despesas_fixas) +
    adaptValue(userInput.despesas_operacionais) +
    adaptValue(taxaExposicaoClassico) +
    adaptValue(produto.frete_mercado_envios)

  const totalDespesasPremium =
    adaptValue(impostoPremium) +
    adaptValue(userInput.despesas_fixas) +
    adaptValue(userInput.despesas_operacionais) +
    adaptValue(taxaExposicaoPremium) +
    adaptValue(produto.frete_mercado_envios)

  const markupClassico =
    (adaptValue(produto.preco_venda_produto) -
      adaptValue(userInput.custo_produto)) /
    adaptValue(userInput.custo_produto)

  const markupPremium =
    (adaptValue(precoVendaProdutoPremium) -
      adaptValue(userInput.custo_produto)) /
    adaptValue(userInput.custo_produto)

  const lucroAdicionalClassico =
    (adaptValue(produto.preco_venda_produto) -
      adaptValue(userInput.custo_produto) -
      totalDespesasClassico) /
    (adaptValue(userInput.custo_produto) + totalDespesasClassico)

  const lucroAdicionalPremium =
    (adaptValue(precoVendaProdutoPremium) -
      adaptValue(userInput.custo_produto) -
      totalDespesasPremium) /
    (adaptValue(userInput.custo_produto) + totalDespesasPremium)

  const lucratividadeClassico =
    (adaptValue(produto.preco_venda_produto) -
      adaptValue(userInput.custo_produto) -
      totalDespesasClassico) /
    adaptValue(produto.preco_venda_produto)

  const lucratividadePremium =
    (adaptValue(precoVendaProdutoPremium) -
      adaptValue(userInput.custo_produto) -
      totalDespesasPremium) /
    adaptValue(precoVendaProdutoPremium)

  const despesasNFClassico =
    adaptValue(impostoClassico) / adaptValue(produto.preco_venda_produto)

  const despesasNFPremium =
    adaptValue(impostoPremium) / precoVendaProdutoPremium

  const freteClassico =
    adaptValue(produto.frete_mercado_envios) / totalDespesasClassico

  const fretePremium =
    adaptValue(produto.frete_mercado_envios) / totalDespesasPremium

  const despesasFixasInformativoClassico =
    adaptValue(userInput.despesas_fixas) / totalDespesasClassico

  const despesasFixasInformativoPremium =
    adaptValue(userInput.despesas_fixas) / totalDespesasPremium

  const despesasOperacionaisInformativoClassico =
    adaptValue(userInput.despesas_operacionais) / totalDespesasClassico

  const despesasOperacionaisInformativoPremium =
    adaptValue(userInput.despesas_operacionais) / totalDespesasPremium

  const taxaExposicaoInformativoClassico =
    adaptValue(taxaExposicaoClassico) / totalDespesasClassico

  const taxaExposicaoInformativoPremium =
    adaptValue(taxaExposicaoPremium) / totalDespesasPremium

  const mercadoLivreInformativoClassico =
    (adaptValue(taxaExposicaoClassico) +
      adaptValue(produto.frete_mercado_envios)) /
    totalDespesasClassico

  const mercadoLivreInformativoPremium =
    (adaptValue(taxaExposicaoPremium) +
      adaptValue(produto.frete_mercado_envios)) /
    totalDespesasPremium

  const outrosImpostosInformativoClassico =
    despesasOperacionaisInformativoClassico +
    despesasFixasInformativoClassico +
    despesasNFClassico

  const outrosImpostosInformativoPremium =
    despesasOperacionaisInformativoPremium +
    despesasFixasInformativoPremium +
    despesasNFPremium

  function handleChangeClassico(e) {
    const { name, value } = e.target

    setProduto((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  function handleChangeDataInput(e) {
    const { name, value } = e.target

    setUserInput((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  function handleChangeParametrosCusto(e) {
    const { name, value } = e.target

    setParametrosCusto((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function handleSavePrices() {
    try {
      setIsSavePricesLoading(true)

      await apinode.patch(
        `/produtos/prices/${product.codproduto}/${localStorage.idconta}`,
        {
          precocusto: adaptValue(userInput.custo_produto),
          precovenda: adaptValue(produto.preco_venda_produto),
        },
      )

      toast.success('Preços atualizados com sucesso')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao salvar os preços')
    } finally {
      setIsSavePricesLoading(false)
    }
  }

  useEffect(() => {
    let userInputData = localStorage.getItem('userInput')
    let parametrosCustoData = localStorage.getItem('parametrosCusto')

    if (userInputData) {
      userInputData = JSON.parse(userInputData)
    }

    if (parametrosCustoData) {
      setParametrosCusto(JSON.parse(parametrosCustoData))
    }

    if (product?.precocusto) {
      setUserInput({
        custo_produto: product.precocusto,
      })

      if (userInputData) {
        setUserInput({
          quantidade: userInputData?.quantidade,
          imposto: userInputData?.imposto,
          despesas_fixas: userInputData?.despesas_fixas,
          despesas_operacionais: userInputData?.despesas_operacionais,
        })
      }
    } else {
      if (userInputData) {
        setUserInput(userInputData)
      }
    }

    if (product?.precovenda) {
      setProduto((prevState) => ({
        ...prevState,
        preco_venda_produto: product.precovenda,
      }))
    }
  }, [product?.precocusto, product?.precovenda])

  return (
    <>
      <Navbar />

      <Container className="mt-page">
        {localStorage?.admin === 'SIM' ? (
          <>
            <>
              <Center gap={5}>
                <img
                  src={belaHomeSvg}
                  style={{
                    width: 60,
                    height: 60,
                  }}
                />

                <h1
                  style={{
                    margin: 0,
                  }}
                >
                  Cálculo Real Dos Lucros
                </h1>
              </Center>

              <CustomButton
                title="Inserir Parâmetros Custo"
                onClick={() => setIsParametrosModalOpen(true)}
              >
                <GearFill />
              </CustomButton>

              {product?.sku && (
                <Row className="mt-3">
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '100px',
                    }}
                  >
                    <h6>
                      <strong>{product?.sku}</strong> | {product?.descricao} |{' '}
                      <strong>Preço Custo:</strong>{' '}
                      {formatValue(product?.precocusto)} |{' '}
                      <strong>Preço Venda:</strong>{' '}
                      {formatValue(product?.precovenda)}
                    </h6>

                    <CustomButton
                      title="Salvar Preço de Custo e Venda"
                      isDisabled={
                        !userInput.custo_produto || !produto.preco_venda_produto
                      }
                      onClick={handleSavePrices}
                      isLoading={isSavePricesLoading}
                      isLoadingText="Salvando..."
                    >
                      <CashCoin />
                    </CustomButton>
                  </div>
                </Row>
              )}

              <Container>
                <Row>
                  <Col>
                    <Table
                      bordered
                      responsive
                    >
                      <thead>
                        <tr>
                          <th colspan="2">
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                              }}
                            >
                              Valores definidos pelo usuário
                              <CustomButton
                                title="Salvar"
                                onClick={() => {
                                  localStorage.setItem(
                                    'userInput',
                                    JSON.stringify(userInput),
                                  )

                                  toast.success(
                                    'Informações salvas com sucesso',
                                  )
                                }}
                              >
                                <FloppyFill />
                              </CustomButton>
                            </div>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>Quantidade</td>
                          <td>
                            <CustomDecimalInput
                              name="quantidade"
                              value={userInput.quantidade}
                              onChange={handleChangeDataInput}
                            />
                          </td>
                        </tr>

                        <tr>
                          <td>Custo do Produto</td>
                          <td>
                            <CustomPriceInput
                              name="custo_produto"
                              value={userInput.custo_produto}
                              onChange={handleChangeDataInput}
                            />
                          </td>
                        </tr>

                        <tr>
                          <td>Imposto (%)</td>
                          <td>
                            <CustomDecimalInput
                              suffix="%"
                              name="imposto"
                              value={userInput.imposto}
                              onChange={handleChangeDataInput}
                            />
                          </td>
                        </tr>

                        <tr>
                          <td>Despesas Fixas</td>
                          <td>
                            <CustomPriceInput
                              name="despesas_fixas"
                              value={userInput.despesas_fixas}
                              onChange={handleChangeDataInput}
                            />
                          </td>
                        </tr>

                        <tr>
                          <td>Despesas Operacionais</td>
                          <td>
                            <CustomPriceInput
                              name="despesas_operacionais"
                              value={userInput.despesas_operacionais}
                              onChange={handleChangeDataInput}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>

                  <Col>
                    <Table
                      bordered
                      responsive
                    >
                      <thead>
                        <tr>
                          <th>PRODUTO</th>
                          <th>
                            {`CLÁSSICO ${parametrosCusto.comissao_venda_classico && `(${parametrosCusto.comissao_venda_classico})`}`}
                          </th>
                          <th>
                            {`PREMIUM ${parametrosCusto.comissao_venda_premium && `(${parametrosCusto.comissao_venda_premium})`}`}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>Envio</td>
                          <td>Frete Grátis</td>
                          <td>Frete Grátis</td>
                        </tr>
                        <tr>
                          <td>Custo do Produto</td>
                          <td>{custoProdutoClassico}</td>
                          <td>{custoProdutoPremium}</td>
                        </tr>
                        <tr>
                          <td>Imposto</td>
                          <td>{impostoClassico}</td>
                          <td>{impostoPremium}</td>
                        </tr>

                        <tr>
                          <td>Despesas Fixas</td>
                          <td>{userInput.despesas_fixas}</td>
                          <td>{userInput.despesas_fixas}</td>
                        </tr>
                        <tr>
                          <td>Despesas Operacionais</td>
                          <td>{userInput.despesas_operacionais}</td>
                          <td>{userInput.despesas_operacionais}</td>
                        </tr>
                        <tr>
                          <td>Taxa de Exposição</td>
                          <td>{taxaExposicaoClassico}</td>
                          <td>{taxaExposicaoPremium}</td>
                        </tr>
                        <tr>
                          <td>Frete Mercado Envios</td>
                          <td colSpan={2}>
                            <CustomPriceInput
                              name="frete_mercado_envios"
                              value={produto.frete_mercado_envios}
                              onChange={handleChangeClassico}
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>Preço de Venda do Produto</td>
                          <td>
                            <CustomPriceInput
                              name="preco_venda_produto"
                              value={produto.preco_venda_produto}
                              onChange={handleChangeClassico}
                            />
                          </td>
                          <td>{formatValue(precoVendaProdutoPremium)}</td>
                        </tr>
                        <tr>
                          <td>Lucro</td>
                          <td
                            style={{
                              color:
                                adaptValue(lucroClassico) < 0 ? 'red' : 'green',
                            }}
                          >
                            {lucroClassico}
                          </td>
                          <td
                            style={{
                              color:
                                adaptValue(lucroPremium) < 0 ? 'red' : 'green',
                            }}
                          >
                            {lucroPremium}
                          </td>{' '}
                        </tr>
                        <tr>
                          <td>Margem de Lucro</td>
                          <td
                            style={{
                              color:
                                adaptValue(lucratividadeClassico) < 0
                                  ? 'red'
                                  : 'green',
                            }}
                          >
                            {formatPercentage(lucratividadeClassico)}
                          </td>
                          <td
                            style={{
                              color:
                                adaptValue(lucratividadePremium) < 0
                                  ? 'red'
                                  : 'green',
                            }}
                          >
                            {formatPercentage(lucratividadePremium)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Table
                      bordered
                      responsive
                    >
                      <thead>
                        <tr>
                          <th colspan="2">Informativo Adicional Clássico</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>Total de Despesas</td>
                          <td>{formatValue(totalDespesasClassico)}</td>
                        </tr>

                        <tr>
                          <td>Custo</td>
                          <td>{userInput.custo_produto}</td>
                        </tr>

                        <tr>
                          <td>Valor Venda</td>
                          <td>{produto.preco_venda_produto}</td>
                        </tr>

                        <tr>
                          <td>Markup (%)</td>
                          <td>{formatPercentage(markupClassico)}</td>
                        </tr>

                        <tr>
                          <td>Lucro (%)</td>
                          <td>{formatPercentage(lucroAdicionalClassico)}</td>
                        </tr>

                        <tr>
                          <td>Lucratividade (%)</td>
                          <td>{formatPercentage(lucratividadeClassico)}</td>
                        </tr>

                        <tr>
                          <td>Valor de Lucro</td>
                          <td>{lucroClassico}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>

                  <Col>
                    <Table
                      bordered
                      responsive
                    >
                      <thead>
                        <tr>
                          <th colspan="2">% Informativo Clássico</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>% Despesas NF</td>
                          <td>{formatPercentage(despesasNFClassico)}</td>
                        </tr>

                        <tr>
                          <td>% Frete</td>
                          <td>{formatPercentage(freteClassico)}</td>
                        </tr>

                        <tr>
                          <td>% Despesas Fixas</td>
                          <td>
                            {formatPercentage(despesasFixasInformativoClassico)}
                          </td>
                        </tr>

                        <tr>
                          <td>% Despesas Oper.</td>
                          <td>
                            {formatPercentage(
                              despesasOperacionaisInformativoClassico,
                            )}
                          </td>
                        </tr>

                        <tr>
                          <td>% Taxa Exposição</td>
                          <td>
                            {formatPercentage(taxaExposicaoInformativoClassico)}
                          </td>
                        </tr>

                        <tr>
                          <td>% Mercado Livre</td>
                          <td>
                            {formatPercentage(mercadoLivreInformativoClassico)}
                          </td>
                        </tr>

                        <tr>
                          <td>% Outros (Imp. Fixas. Oper.)</td>
                          <td>
                            {formatPercentage(
                              outrosImpostosInformativoClassico,
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>

                  <Col>
                    <Table
                      bordered
                      responsive
                    >
                      <thead>
                        <tr>
                          <th colspan="2">Informativo Adicional Premium</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td>Total de Despesas</td>
                          <td>{formatValue(totalDespesasPremium)}</td>
                        </tr>

                        <tr>
                          <td>Custo</td>
                          <td>{userInput.custo_produto}</td>
                        </tr>

                        <tr>
                          <td>Valor Venda</td>
                          <td>{formatValue(precoVendaProdutoPremium)}</td>
                        </tr>

                        <tr>
                          <td>Markup (%)</td>
                          <td>{formatPercentage(markupPremium)}</td>
                        </tr>

                        <tr>
                          <td>Lucro (%)</td>
                          <td>{formatPercentage(lucroAdicionalPremium)}</td>
                        </tr>

                        <tr>
                          <td>Lucratividade (%)</td>
                          <td>{formatPercentage(lucratividadePremium)}</td>
                        </tr>

                        <tr>
                          <td>Valor de Lucro</td>
                          <td>{lucroPremium}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>

                  <Col>
                    <Table
                      bordered
                      responsive
                    >
                      <thead>
                        <tr>
                          <th colspan="2">% Informativo Premium</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>% Despesas NF</td>
                          <td>{formatPercentage(despesasNFPremium)}</td>
                        </tr>

                        <tr>
                          <td>% Frete</td>
                          <td>{formatPercentage(fretePremium)}</td>
                        </tr>

                        <tr>
                          <td>% Despesas Fixas</td>
                          <td>
                            {formatPercentage(despesasFixasInformativoPremium)}
                          </td>
                        </tr>

                        <tr>
                          <td>% Despesas Oper.</td>
                          <td>
                            {formatPercentage(
                              despesasOperacionaisInformativoPremium,
                            )}
                          </td>
                        </tr>

                        <tr>
                          <td>% Taxa Exposição</td>
                          <td>
                            {formatPercentage(taxaExposicaoInformativoPremium)}
                          </td>
                        </tr>

                        <tr>
                          <td>% Mercado Livre</td>
                          <td>
                            {formatPercentage(mercadoLivreInformativoPremium)}
                          </td>
                        </tr>

                        <tr>
                          <td>% Outros (Imp. Fixas. Oper.)</td>
                          <td>
                            {formatPercentage(outrosImpostosInformativoPremium)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Container>
            </>
          </>
        ) : (
          <h1>Acesso não permitido</h1>
        )}
      </Container>

      {isParametrosModalOpen && (
        <Modal
          show={isParametrosModalOpen}
          onHide={() => setIsParametrosModalOpen(false)}
          centered
        >
          <Modal.Header>
            <Modal.Title>Parâmetros Custo</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Table
              bordered
              responsive
            >
              <tbody>
                <tr>
                  <td>Preço de Venda até</td>
                  <td>
                    <CustomPriceInput
                      name="preco_venda_ate"
                      value={parametrosCusto.preco_venda_ate}
                      onChange={handleChangeParametrosCusto}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Comissão de Venda Clássico</td>
                  <td>
                    <CustomDecimalInput
                      suffix="%"
                      name="comissao_venda_classico"
                      value={parametrosCusto.comissao_venda_classico}
                      onChange={handleChangeParametrosCusto}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Comissão de Venda Premium</td>
                  <td>
                    <CustomDecimalInput
                      suffix="%"
                      name="comissao_venda_premium"
                      value={parametrosCusto.comissao_venda_premium}
                      onChange={handleChangeParametrosCusto}
                    />
                  </td>
                </tr>

                <tr>
                  <td>Taxa de Venda</td>
                  <td>
                    <CustomPriceInput
                      name="taxa_venda"
                      value={parametrosCusto.taxa_venda}
                      onChange={handleChangeParametrosCusto}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>

          <Modal.Footer>
            <CustomButton
              title="Salvar"
              onClick={() => {
                {
                  localStorage.setItem(
                    'parametrosCusto',
                    JSON.stringify(parametrosCusto),
                  )

                  setIsParametrosModalOpen(false)

                  toast.success('Informações salvas com sucesso')
                }
              }}
            >
              <FloppyFill />
            </CustomButton>
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}
